// extracted by mini-css-extract-plugin
export default {"started_head":"GetStartedToday_started_head__NtBFn"};